import { ReactNode } from 'react';
import { Box } from '../box/box';
import { Text } from '../text/text';
import { linkStyles } from './user-menu.css';

export const UserMenuLink = ({
  onClick,
  children,
}: {
  onClick: () => void;
  children: ReactNode;
}) => {
  return (
    <Box onClick={onClick} className={linkStyles}>
      <Text css={{ fontWeight: 500 }} variant="body1">
        {children}
      </Text>
    </Box>
  );
};
